export interface ModuleState {
  submodule: string;
  moduleSelected: string;
}

export const initialState: ModuleState = { moduleSelected: null, submodule: null };
